/* global Conf */
import { observable, computed, action } from 'mobx'
import DataRequester from '../services/data'
import AuthService from '../services/auth'
import * as defaultConst from '../constants/default_constants'

export default class UserState {
  constructor () {
    this.auth = new AuthService(Conf.auth0clientID, Conf.auth0domain)
    // init data requester here coz we are about set auth headers to it ..
    this.requester = new DataRequester(this.on401.bind(this))
    this.onError = this.onRequesterError.bind(this)
    this.prefSaveDelay = 0
  }

  initUser (cb) {
    const token = this.auth.getToken()
    if (token === null) {
      this.loggedUser = null
      this.authToken = null
      cb()
    } else {
      this.authToken = token
      this._setToken2Service()
      this.requester.call('/reports?type=report').then(res => {
        this.reports = res.data
      }).catch(this.onRequesterError.bind(this))
      this.auth.getProfile(token, this.requester)
        .then((profile) => {
          if (profile.rights && Object.keys(profile.rights).length === 0 &&
              Conf.rightsenabled) {
            this.addMessage(this.__('you don\' have any rights'), 'warning')
            return this.router.goTo(this.views.login, {}, this)
          }
          this.loggedUser = profile
          cb()
        })
        .catch(cb)
    }
  }

  @observable loggedUser = null
  @observable authToken = null

  @observable userCss = localStorage.getItem(defaultConst.TEMPLATE_SKIN_KEY) || 'yeti'

  @computed get userLoggedIn () {
    return this.authToken !== null
  }

  hasRight = (entity, desired = null) => {
    const right = this.loggedUser && this.loggedUser.rights[entity]
    return right && (desired ? right.indexOf(desired) >= 0 : true)
  }

  @computed get userIsAdmin () {
    return this.loggedUser !== null && this.loggedUser.user_metadata && this.loggedUser.user_metadata.gid === Conf.adminGID
  }

  @computed get userIsOp () {
    return this.loggedUser !== null && this.loggedUser.user_metadata && this.loggedUser.user_metadata.gid === Conf.opGID
  }

  _setToken2Service () {
    this.requester.setAuth({ Authorization: `Bearer ${this.authToken}` })
    this.initAws()
  }

  on401 (err) {
    if (err) {
      // console.error(err)
    }
    if (this.loggedUser !== null) {
      this.logout()
    }
    if (this.router.currentView !== this.views.login) {
      this.router.goTo(this.views.login, {}, this)
    }
  }

  // TODO: spojit s initUser
  @action
  performLogin (onComplete) {
    return this.auth.login(this.requester)
      .then((token) => {
        this.authToken = token
        this._setToken2Service()
        return this.auth.getProfile(token, this.requester)
      })
      .then((profile) => {
        if (profile.rights && Object.keys(profile.rights).length === 0 &&
            Conf.rightsenabled) {
          this.addMessage(this.__('you don\' have any rights'), 'warning')
          return
        }
        this.requester.call('/reports?type=report').then(res => {
          this.reports = res.data
        }).catch(this.onRequesterError.bind(this))
        this.loggedUser = profile

        if (Object.prototype.hasOwnProperty.call(this.loggedUser, 'user_metadata') &&
        Object.prototype.hasOwnProperty.call(this.loggedUser.user_metadata, 'preferences')) {
          Object.keys(this.loggedUser.user_metadata.preferences).forEach(key => {
            const value = this.loggedUser.user_metadata.preferences[key]
            localStorage.setItem(key, value)
            switch (key) {
            case defaultConst.TEMPLATE_SKIN_KEY:
              this.switchCss(value)
              break
            case 'dateFilterValue':
              this.dateFilterValue = value
              break
            case 'regionFilterValue':
              this.regionFilterValue = value
              break
            case 'historyFilterData':
              this.historicDataFilterActive = value
              break
            }
          })
        }

        if (this.router.bkp) {
          const bkp = this.router.bkp
          delete this.router.bkp
          this.router.goTo(bkp[0], JSON.parse(bkp[1]), this, bkp[2] && JSON.parse(bkp[2]))
        } else {
          this.router.goTo(this.views.entity_list, {
            entityname: 'films'
          }, this, { _page: 1 })
        }
      })
      .catch((err) => {
        this.addMessage(err, 'error', 6000)
      })
  }

  @action
  logout () {
    this.auth.logout()
    this.loggedUser = null
    this.authToken = null
    this.options = {}

    localStorage.clear()
    if (!this.router.bkp && this.router.currentView) {
      this.router.bkp = [
        this.router.currentView,
        JSON.stringify(this.router.params),
        JSON.stringify(this.router.queryParams)
      ]
      if (this.cv && this.cv.record && this.cv.record.size > 0) { // save current form data (record)
        this.router.recordBackup = JSON.parse(JSON.stringify(this.cv.record))
      }
    }
    if (this.router.currentView !== this.views.login) {
      this.router.goTo(this.views.login, {}, this)
    }
  }

  @action
  switchCss (newcss = 'yeti') {
    this.setUserPreferences(defaultConst.TEMPLATE_SKIN_KEY, newcss)
    this.userCss = newcss
  }

  getUserPreferences = (key) => {
    return this.loggedUser &&
    Object.prototype.hasOwnProperty.call(this.loggedUser, 'user_metadata') &&
    Object.prototype.hasOwnProperty.call(this.loggedUser.user_metadata, 'preferences') &&
    Object.prototype.hasOwnProperty.call(this.loggedUser.user_metadata.preferences, key)
      ? this.loggedUser.user_metadata.preferences[key]
      : localStorage.getItem(key) || undefined
  }

  setUserPreferences (key, value = undefined) {
    if (!this.loggedUser) {
      return false
    }
    if (!Object.prototype.hasOwnProperty.call(this.loggedUser, 'user_metadata')) {
      this.loggedUser.user_metadata = {}
    }
    if (!Object.prototype.hasOwnProperty.call(this.loggedUser.user_metadata, 'preferences')) {
      this.loggedUser.user_metadata.preferences = {}
    }
    if (value === undefined) {
      delete this.loggedUser.user_metadata.preferences[key]
      localStorage.removeItem(key)
    } else {
      this.loggedUser.user_metadata.preferences[key] = value
      localStorage.setItem(key, value)
    }
    const options = {
      method: 'patch',
      url: `https://${Conf.auth0domain}/api/v2/users/${(this.loggedUser.user_id)}`,
      headers: { authorization: `Bearer ${this.authToken}`, 'Content-Type': 'application/json; charset=UTF-8', Accept: 'application/json' },
      data: { user_metadata: this.loggedUser.user_metadata },
      json: true
    }
    // security limit for auth0 overloading
    if (this.prefSaveDelay < 10) {
      this.prefSaveDelay++
      new Promise((resolve) => setTimeout(resolve, (this.prefSaveDelay - 1) * 3000)).then(() => {
        this.requester.callExternalRes(options)
          .then(() => { this.prefSaveDelay-- })
          .catch((err) => {
            this.addMessage(err, 'error', 4000)
          })
      })
    }
  }
}
